/**
 * @copyright Chianyu Inc., 2018 and onwards
 * @author Shengyi Liu
 * @date  2019/3/5 15:17
 * @des 请求封装
 */

import axios from 'axios'
import {
  getTimeZoneGmt
} from '@/base/util/timeutil'
import {isLocalEn} from '@/base/i18n'
import {uuid} from '../util/uuid'

const Constant = require('@/base/constants')
import {makeTrashable} from '@/base/util/trashablepromise'
import {
  handleNativeException,
  handleServiceException
} from '@/base/util/exeptionutil'
import {getDeviceId} from '../util/deviceutil'

const pushId = uuid()

function addFetchPushId (params) {
  if (!params) {
    params = {pushId: pushId}
  } else {
    params['pushId'] = pushId
  }
  return params
}

function get_headers () {
  let headers = {
    'Cache-Control': 'no-cache'
  }
  headers.timezone = getTimeZoneGmt() // 时区
  headers.lang = isLocalEn() ? 'en_US' : 'zh_CN'// 语言
  let deviceId = getDeviceId()
  if (deviceId) {
    headers['deviceId'] = deviceId
  }
  return headers
}

function get_json_headers () {
  let json_headers = {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache'
  }
  json_headers.timezone = getTimeZoneGmt() // 时区
  json_headers.lang = isLocalEn() ? 'en_US' : 'zh_CN'// 语言
  let deviceId = getDeviceId()
  if (deviceId) {
    json_headers['deviceId'] = deviceId
  }
  return json_headers
}

/**
 * 发送get请求
 * @param path 请求路径
 * @param params 请求参数
 * @returns {Promise<any>}
 */
export function get (path, params) {
  return makeTrashable(new Promise((resolve, reject) => {
    path = addPathParams(path, addFetchPushId(params))
    axios.get(path, {headers: get_headers()}).then((response) => {
      doResult(response, resolve, reject)
    }).catch((error) => {
      doError(error, resolve, reject)
    })
  }))
}

/**
 * 发送post请求（参数使用url参数形式）
 * @param path 请求路径
 * @param params 请求参数
 * @returns {Promise<any>}
 */
export function post (path, params) {
  return makeTrashable(new Promise((resolve, reject) => {
    const urlParams = new URLSearchParams()
    if (params) {
      Object.keys(params).forEach(function (key) {
        urlParams.append(key, params[key])
      })
    }
    path = addPathParams(path, addFetchPushId())
    axios.post(path, urlParams, {headers: get_headers()}).then((response) => {
      doResult(response, resolve, reject)
    }).catch((error) => {
      doError(error, resolve, reject)
    })
  }))
}

/**
 * 发送post请求（参数使用json形式）
 * @param path 请求路径
 * @param json 请求参数
 * @returns {Promise<any>}
 */
export function postJson (path, json) {
  return makeTrashable(new Promise((resolve, reject) => {
    //$log(json)
    path = addPathParams(path, addFetchPushId())
    axios.post(path, json, {headers: get_json_headers()}).then((response) => {
      doResult(response, resolve, reject)
    }).catch((error) => {
      doError(error, resolve, reject)
    })
  }))
}

/**
 * Web端上传公共附件
 * @param file
 * @param Number tType
 */
export function uploadWebAttach (file, tType = 101, fileName = '') {
  let params = {}
  params.size = file.size
  file.key && (params.key = file.key)
  fileName && (params.name = fileName)
  params.file = file
  return formPost(Constant.API_SERVER_URL + `uploadfile?t=${tType}`, params, true)
}

/**
 * 处理本地错误
 * @param error
 * @param resolve
 * @param reject
 */
function doError (error, resolve, reject) {
  let errorInfo = handleNativeException(error)
  reject(errorInfo)
}

function doResult (res, resolve, reject) {
  if (res.status = 200) {
    var data = res.data
    if (data.code != 0) {
      data.showErr = true
      data.toLogin = true
      reject(data)
      setTimeout(() => {
        // 拦截超时(响应码：3000)请求
        if (!Constant.DEBUG && data.toLogin && data.code == 3000) {
          data.showErr = false // 不提示错误信息
          window.location.assign(Constant.LOGIN_URL + encodeURIComponent(window.location.href))
        }

        handleServiceException(data.code, data.msg, data.showErr)

      }, 0)
    } else {
      resolve(data.data)
    }
  } else {
    reject({
      code: res.status,
      message: res.statusText
    })
  }
}

/**
 * 表单提交
 * @param path
 * @param params
 * @param isFileUpload 是否是文件上传，因为文件上传和其它数据返回的数据不一致
 * @returns {Promise<any>}
 */
export function formPost (path, params, isFileUpload = false) {
  return new Promise((resolve, reject) => {
    let formData = new FormData()
    for (let key in params) {
      formData.append(key, params[key])
    }
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
    path = addPathParams(path, addFetchPushId())
    axios.post(path, formData, config).then((response) => {
      if (isFileUpload) {
        let data = response.data
        response.data = {
          code: data.errno,
          data: data,
          msg: '操作成功',
        }
      }
      doResult(response, resolve, reject)
    }).catch((error) => {
      doError(error, resolve, reject)
    })
  })
}

/**
 * 将参数添加到url之后
 * @param path
 * @param params
 * @returns {*}
 */
function addPathParams (path, params) {
  if (path && params) {
    let entrys = Object.keys(params)
    let hasParams = (path.indexOf('?') !== -1)
    entrys.forEach(function (value, index) {
      if (index === 0 && !hasParams) {
        path += '?' + value + '=' + encodeURIComponent(params[value])
      } else {
        path += '&' + value + '=' + encodeURIComponent(params[value])
      }
    })
  }
  return path
}



// WEBPACK FOOTER //
// ./src/base/store/fetch.js